module.exports = __webpack_public_path__ + "img/delivery_man.baa94de4.png";